import React from 'react';
import CargaTarjeta from '../../comun/CargaTarjeta';

/**
 * Tarjeta «Compraventa de bienes raíces» del AT 2026: el Excel «Detalle_DJ_2890»
 * (Formulario 2890 de los notarios) que el SII entrega a la persona. Su lector está en
 * src/services/declaracionRenta/empresarioIndividual/2026/compraventaBienesRaices/lector.js
 */
const COLUMNAS = [
  { campo: 'rol', titulo: 'Rol' },
  { campo: 'comuna', titulo: 'Comuna' },
  { campo: 'fecha_escritura', titulo: 'Fecha escritura', formato: 'fecha' },
  { campo: 'monto_compra', titulo: 'Monto compra', monto: true },
  { campo: 'monto_venta', titulo: 'Monto venta', monto: true },
  { campo: 'porcentaje_transado', titulo: 'Porcentaje transado', formato: 'porcentaje' },
  { campo: 'valor_pagado_contado', titulo: 'Pagado al contado', monto: true },
  { campo: 'repertorio', titulo: 'Repertorio' },
  { campo: 'rut_notario', titulo: 'RUT notario' },
  { campo: 'estado_sii', titulo: 'Estado SII' },
];

const CompraventaBienesRaicesPage = ({ anioTributario, idCompany }) => (
  <CargaTarjeta
    anioTributario={anioTributario}
    idCompany={idCompany}
    tarjeta="compraventa-bienes-raices"
    columnas={COLUMNAS}
    extensiones=".xls,.xlsx"
    ayuda={(
      <>
        Sube el Excel <strong>Detalle_DJ_2890_{anioTributario}00_&lt;RUT&gt;.xlsx</strong> que descargas del SII en
        Información de terceros: las compraventas de bienes raíces del año {anioTributario - 1} que informaron los
        notarios en el Formulario 2890. El archivo no se guarda.
      </>
    )}
  />
);

export default CompraventaBienesRaicesPage;
